import { render, staticRenderFns } from "./StartHealth.vue?vue&type=template&id=172b6a2e"
import script from "./StartHealth.vue?vue&type=script&lang=js"
export * from "./StartHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports